module.exports = __webpack_public_path__ + "static/media/flechanegra.a7117c1c.svg";